"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _reactDom = require("react-dom");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _loader = _interopRequireDefault(require("../loader"));

var _utils = require("../utils");

var _input = _interopRequireDefault(require("../input"));

var _icon = _interopRequireDefault(require("../icon"));

var _messages = _interopRequireDefault(require("./messages"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_style["default"]);

var _ref2 = /*#__PURE__*/_jsx("div", {});

var Item = function Item(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? _ref2 : _ref$tag,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      label = _ref.label,
      extraLabel = _ref.extraLabel,
      description = _ref.description,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'row' : _ref$appearance,
      icon = _ref.icon,
      _ref$iconAlign = _ref.iconAlign,
      iconAlign = _ref$iconAlign === void 0 ? 'left' : _ref$iconAlign,
      customIcon = _ref.customIcon,
      color = _ref.color,
      disabled = _ref.disabled,
      _ref$itemRef = _ref.itemRef,
      itemRef = _ref$itemRef === void 0 ? function () {
    return void 0;
  } : _ref$itemRef,
      extraLabelClass = _ref.extraLabelClass,
      className = _ref.className,
      _ref$separated = _ref.separated,
      separated = _ref$separated === void 0 ? false : _ref$separated,
      _ref$dataId = _ref.dataId,
      dataId = _ref$dataId === void 0 ? '' : _ref$dataId,
      _ref$breakLabelText = _ref.breakLabelText,
      breakLabelText = _ref$breakLabelText === void 0 ? false : _ref$breakLabelText,
      rest = _objectWithoutProperties(_ref, ["tag", "active", "label", "extraLabel", "description", "appearance", "icon", "iconAlign", "customIcon", "color", "disabled", "itemRef", "extraLabelClass", "className", "separated", "dataId", "breakLabelText"]);

  return /*#__PURE__*/_react["default"].cloneElement(tag, _objectSpread(_objectSpread({}, rest), {}, {
    ref: typeof tag.type === 'function' ? null : itemRef,
    className: cx('xsui-dropdown-item', "xsui-dropdown-item--appearance-".concat(appearance), active && 'xsui-dropdown-item--active', (icon || customIcon) && "xsui-dropdown-item--icon-align-".concat(iconAlign), disabled && 'xsui-dropdown-item--disabled', separated && 'xsui-dropdown-item--separated', className),
    'data-value': rest.value,
    'data-id': dataId,
    children: /*#__PURE__*/_jsx(_react.Fragment, {}, void 0, icon && /*#__PURE__*/_jsx("div", {
      className: cx('xsui-dropdown-item__icon'),
      style: {
        color: color
      }
    }, void 0, /*#__PURE__*/_jsx(_icon["default"], {
      name: icon
    })), !icon && customIcon && /*#__PURE__*/_jsx("div", {
      className: cx('xsui-dropdown-item__icon')
    }, void 0, customIcon), /*#__PURE__*/_jsx("div", {
      className: cx('xsui-dropdown-item__entry')
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: cx('xsui-dropdown-item__row')
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: cx('xsui-dropdown-item__label', breakLabelText && 'xsui-dropdown-item__label--break-text'),
      style: {
        color: color
      }
    }, void 0, label), extraLabel instanceof Array ? extraLabel.map(function (a, index) {
      return /*#__PURE__*/_jsx("div", {
        className: cx('xsui-dropdown-item__extra-label', extraLabelClass)
      }, "label--".concat(index), a);
    }) : /*#__PURE__*/_jsx("div", {
      className: cx('xsui-dropdown-item__extra-label', extraLabelClass)
    }, void 0, extraLabel)), description && /*#__PURE__*/_jsx("div", {
      className: cx('xsui-dropdown-item__description')
    }, void 0, description)))
  }));
};

var _ref3 = /*#__PURE__*/_jsx(_loader["default"], {
  fullscreen: true,
  size: "lg"
});

var Options = /*#__PURE__*/function (_PureComponent) {
  _inherits(Options, _PureComponent);

  var _super = _createSuper(Options);

  function Options() {
    var _this;

    _classCallCheck(this, Options);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "containerRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "optionsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "activeItemRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "positionPredetermined", !!_this.props.position);

    _defineProperty(_assertThisInitialized(_this), "state", {
      search: '',
      position: _this.props.position || 'bottom'
    });

    _defineProperty(_assertThisInitialized(_this), "layoutRef", /*#__PURE__*/(0, _react.createRef)());

    _defineProperty(_assertThisInitialized(_this), "determineDropdownPosition", function () {
      _this.setState({
        position: (0, _utils.dropdownVisible)(_this.containerRef, _this.props.buttonRef) ? 'bottom' : 'top'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      var onScroll = _this.props.onScroll;
      var selectHeight = 84;
      var blockIndents = 10;

      if (_this.containerRef && _this.optionsRef) {
        var containerInnerHeight = _this.containerRef.offsetHeight - blockIndents;
        var scrollTop = _this.optionsRef.scrollHeight - containerInnerHeight + selectHeight;

        if (scrollTop === _this.containerRef.scrollTop) {
          onScroll();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setContainerRef", function (ref) {
      return _this.containerRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "setOptionsRef", function (ref) {
      return _this.optionsRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "setItemRef", function (ref) {
      return _this.activeItemRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (item) {
      item.onClick && item.onClick();

      _this.props.onChange(item.value);
    });

    _defineProperty(_assertThisInitialized(_this), "filterItem", function (item, string) {
      return item.label.toString().toLowerCase().indexOf(string) > -1 || item.value && item.value.toString().toLowerCase().indexOf(string) > -1 || item.extraLabel && item.extraLabel.toString().toLowerCase().indexOf(string) > -1 || item.description && item.description.toString().toLowerCase().indexOf(string) > -1;
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptions", function (filterredItems) {
      var _this$props = _this.props,
          intl = _this$props.intl,
          size = _this$props.size,
          align = _this$props.align,
          appearance = _this$props.appearance,
          searchable = _this$props.searchable,
          separated = _this$props.separated,
          fullWidth = _this$props.fullWidth,
          style = _this$props.style,
          buttonRef = _this$props.buttonRef,
          fetching = _this$props.fetching;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: _this.setContainerRef,
        className: cx('xsui-dropdown__container', "xsui-dropdown__container--size-".concat(size), "xsui-dropdown__container--appearance-".concat(appearance), !buttonRef && "xsui-dropdown__container--align-".concat(align), "xsui-dropdown__container--position-".concat(_this.state.position), buttonRef && "xsui-dropdown__container--position-".concat(_this.state.position, "-hovered"), separated && 'xsui-dropdown__container--separated', fullWidth && 'xsui-dropdown__container--full-width'),
        style: style
      }, searchable && /*#__PURE__*/_jsx("div", {
        className: cx('xsui-dropdown__container__search')
      }, void 0, /*#__PURE__*/_jsx(_input["default"], {
        input: {
          name: 'search',
          value: _this.state.search,
          onChange: function onChange(e) {
            return _this.setState({
              search: e.target.value
            });
          }
        },
        size: "sm",
        offset: "left",
        icon: "search",
        autoComplete: "off",
        placeholder: intl.formatMessage(_messages["default"].search)
      })), /*#__PURE__*/_react["default"].createElement("div", {
        ref: _this.setOptionsRef
      }, filterredItems.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement(Item, _extends({}, item, {
          iconAlign: item.iconAlign || align.split('-')[0],
          key: "option-".concat(index),
          itemRef: function itemRef(ref) {
            return item.active && _this.setItemRef(ref);
          },
          onClick: function onClick() {
            return _this.handleClick(item);
          }
        }));
      })), fetching && /*#__PURE__*/_jsx("div", {
        className: cx('xsui-dropdown__loader-container')
      }, void 0, _ref3), !filterredItems.length && /*#__PURE__*/_jsx(Item, {
        label: intl.formatMessage(_messages["default"].nothingFound),
        disabled: true
      }));
    });

    return _this;
  }

  _createClass(Options, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.containerRef) {
        this.containerRef.addEventListener('scroll', this.handleScroll);
      }

      if (!this.positionPredetermined) {
        this.determineDropdownPosition();
        window.addEventListener('resize', this.determineDropdownPosition);
      }

      if (this.activeItemRef) {
        // $FlowFixMe ref type for findDOMNode
        var item = (0, _reactDom.findDOMNode)(this.activeItemRef);

        if (item.offsetTop > 100) {
          // $FlowFixMe ref type for findDOMNode
          (0, _reactDom.findDOMNode)(this.containerRef).scrollTop = item.offsetTop - item.clientHeight - 42;
        }
      }

      if (this.props.buttonRef && this.containerRef) {
        var layoutEl = this.layoutRef.current;

        if (!layoutEl || !this.props.buttonRef.current) {
          return;
        }

        var layoutElHeight = this.containerRef.offsetHeight + this.props.buttonRef.current.offsetHeight - 5;
        layoutEl.style.height = "".concat(layoutElHeight, "px");
        layoutEl.style.width = "".concat(this.containerRef.offsetWidth, "px");
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.containerRef) {
        this.containerRef.removeEventListener('scroll', this.handleScroll);
      }

      if (!this.positionPredetermined) {
        window.removeEventListener('resize', this.determineDropdownPosition);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          items = _this$props2.items,
          align = _this$props2.align,
          value = _this$props2.value,
          buttonRef = _this$props2.buttonRef;
      var filterredItems = items.filter(function (a) {
        return _this2.filterItem(a, _this2.state.search.toString().toLowerCase().trim());
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          active: item.active || item.value === value
        });
      });
      return /*#__PURE__*/_jsx(_react.Fragment, {}, void 0, buttonRef ? /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.layoutRef,
        className: cx('xsui-dropdown__layout', "xsui-dropdown__layout-".concat(align), "xsui-dropdown__layout-".concat(this.state.position), "xsui-dropdown__container--align-".concat(align))
      }, this.renderOptions(filterredItems)) : /*#__PURE__*/_jsx(_react.Fragment, {}, void 0, this.renderOptions(filterredItems)));
    }
  }]);

  return Options;
}(_react.PureComponent);

_defineProperty(Options, "defaultProps", {
  position: null,
  size: 'md',
  align: 'left',
  appearance: 'primary',
  searchable: false,
  separated: false,
  fullWidth: false,
  value: null,
  onChange: function onChange() {
    return void 0;
  },
  onScroll: function onScroll() {
    return void 0;
  },
  fetching: false
});

var _default = (0, _reactIntl.injectIntl)(Options);

exports["default"] = _default;